import { Alert, Button, Card, Modal, ModalDialog, Table } from "react-bootstrap";
import BuilderDocumentRow from "./BuilderDocumentRow";
import { useEffect, useState } from "react";
import { deleteBuyerDoc, getBuilderBuyerDocs, getBuilderDocs, uploadBuyerDoc } from "./BuilderDocFuncs";
import { lddGlobalSessionInfo } from "../navigationTypes";
import { useAppSelector } from "../../redux/hooks";
import { lddStateObject } from "../../redux/reducer";
import { getDataReader } from "../../livedataFuncs";
import { BuilderDocType, BuilderFolderType, BuilderStateType } from "./types";
import BuilderFolderRow from "./BuilderFolderRow";
import DeleteModal from "./Modals/DeleteModal";
import UploadModal from "./Modals/UploadModal";
import OverwriteModal from "./Modals/OverwriteModal";
import BuilderInfo from "./BuilderInfo";


export const BuilderDoc = () => {
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const [pubDocs, setPubDocs] = useState<Array<BuilderDocType>>([]);
    const [privDocs, setPrivDocs] = useState<Array<BuilderDocType>>([]);
    const [buyerDocs, setBuyerDocs] = useState<Array<BuilderDocType>>([]);
    const [showContent, setShowContent] = useState<BuilderFolderType>('Root');
    const [deleteModal, setDeleteModal] = useState<{
        show: boolean,
        dname?: string,
        docID?: number,
        msgID?: string
    }>({ show: false });
    const [showUploadModal, setShowUploadModal] = useState<boolean>(false);
    const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
    const [uploadDocLoading, setUploadDocLoading] = useState<boolean>(false);
    const [sortingOrder, setSortingOrder] = useState<boolean>(false);
    const [showOverwriteModal, setShowOverwriteModal] = useState<boolean>(false);
    const [docToUpload, setDocToUpload] = useState<{name: string, ext: string}>({name: null, ext: null});
    const [builderState, setBuilderState] = useState<BuilderStateType>({appId: null, appCode: null, msgID: null});

    useEffect(() => {
        let id: string, appCode: string, msgID: string;
        if (livedataRootContainer?.dataRoot) {
            const DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
            id = DataReaderObj.getAppId();
            appCode = DataReaderObj.getAppCode();
            msgID = DataReaderObj.getVIPInfoMsgID();
            setBuilderState({appId: id, appCode: appCode, msgID: msgID});
        }
    }, [livedataRootContainer.dataRoot])

    useEffect(() => {
        if (builderState.msgID) {
            updateDocuments();
        }
    }, [builderState.msgID])
    
    const updateDocuments = async() => {
        updateSellerDocs();
        // updateBuyerDocs();
    }

    const updateSellerDocs = async() => {
        const docs = await getBuilderDocs(builderState.msgID, sessionInfo);
        setPubDocs(docs.publicFiles ?? []);
        setPrivDocs(docs.privateFiles ?? []);
    }

    const updateBuyerDocs = async() => {
        const buyerDocs = await getBuilderBuyerDocs(builderState.msgID, sessionInfo);
        setBuyerDocs(buyerDocs);
    }

    const handleDeleteBuyerDoc = async() => {
        setDeleteLoading(true);
        const success = await deleteBuyerDoc(deleteModal.docID, deleteModal.msgID, sessionInfo);
        setDeleteLoading(false);
        setDeleteModal({ show: false, dname: null, docID: null });
        updateBuyerDocs();
    }

    const [uploadFile, setUploadFile] = useState<File>(null);

    function getDocNameWithoutExtension(fileName: string) {
        const dotIndex = fileName.lastIndexOf('.');
        if (dotIndex !== -1 && dotIndex < fileName.length - 1) {
          return fileName.substring(0, dotIndex);
        } else {
          return fileName;
        }
    }

    const handleBuyerDocUpload = async(): Promise<void> => {
        try {
            setUploadDocLoading(true);
            // check existing file with duplicate name
            const isDuplicate = buyerDocs.findIndex((doc) => doc.filename === docToUpload.name);
            if (isDuplicate > -1) {
                setShowUploadModal(false);
                setShowOverwriteModal(true);
                setUploadDocLoading(false);
                return;
            }
            const res = await uploadBuyerDoc(builderState.msgID, sessionInfo, uploadFile, docToUpload.name);
            setUploadDocLoading(false);
        } catch (error) {
            console.log(error);
            setUploadDocLoading(false);
        }
        setShowUploadModal(false);
        updateBuyerDocs();
        setUploadFile(null);
        setDocToUpload({name: null, ext: null});
    }

    const handleBuyerDocOverwrite = async(): Promise<void> => {
        try {
            setUploadDocLoading(true);
            const res = await uploadBuyerDoc(builderState.msgID, sessionInfo, uploadFile, docToUpload.name);
            setUploadDocLoading(false);
        } catch (error) {
            console.log(error);
            setUploadDocLoading(false);
        }
        setShowOverwriteModal(false);
        updateBuyerDocs();
        setUploadFile(null);
        setDocToUpload({name: null, ext: null});
    }

    const handleCancelOverwriteModal = () => {
        setDocToUpload({name: null, ext: null});
        setUploadFile(null);
        setShowOverwriteModal(false);
    }

    const handleClick = (sender: 'Seller'|'Buyer', column: 'filename' | 'timestamp') => {
        if (sender === 'Seller') {
            switch (showContent) {
                case "Project":
                    setPubDocs(pubDocs.sort((a, b) => {
                        if ((b[column] && !a[column]) || (a[column] && b[column] && (a[column].toLowerCase() < b[column].toLowerCase()))) {
                            return sortingOrder ? 1 : -1;
                        } else {
                            return sortingOrder ? -1 : 1;
                        }
                    }));
                    setSortingOrder(!sortingOrder);
                    break;
                case "Unit":
                    setPrivDocs(privDocs.sort((a, b) => {
                        if ((b[column] && !a[column]) || (a[column] && b[column] && (a[column].toLowerCase() < b[column].toLowerCase()))) {
                            return sortingOrder ? 1 : -1;
                        } else {
                            return sortingOrder ? -1 : 1;
                        }
                    }));
                    setSortingOrder(!sortingOrder);
                    break;
                case "Root":
                    return;
            }
        } else {
            setBuyerDocs(buyerDocs.sort((a, b) => {
                if ((b[column] && !a[column]) || (a[column] && b[column] && (a[column].toLowerCase() < b[column].toLowerCase()))) {
                    return sortingOrder ? 1 : -1;
                } else {
                    return sortingOrder ? -1 : 1;
                }
            }));
            setSortingOrder(!sortingOrder);
        }
    }

    function tableHeader(sender: 'Seller'|'Buyer'): JSX.Element {
        return (
            <thead>
                <tr>
                    <th style={{ width: '30px' }}></th>
                    <th onClick={() => {handleClick(sender, 'filename')}}><i className="fa-solid fa-sort fa-indicator"></i>Name</th>
                    <th style={{ width: '40px' }}></th>
                    {showContent === "Root"
                        ? <th></th>
                        : <th onClick={() => {handleClick(sender, 'timestamp')}} style={{ width: '190px' }}><i className="fa-solid fa-sort fa-indicator"></i>Uploaded</th>
                    }
                    <th style={{ width: '130px' }}></th>
                </tr>
            </thead>
        );
    }

    function sellerTableBody(): JSX.Element {
        if (showContent === 'Root') {
            return (<tbody>
                <BuilderFolderRow
                    folder={"Project"}
                    onClick={setShowContent}
                />
                <BuilderFolderRow 
                    folder={"Unit"}
                    onClick={setShowContent}
                />
            </tbody>);
        }
        let docsData = pubDocs;
        if (showContent === 'Unit') docsData = privDocs;
        return (<tbody>
                <BuilderFolderRow
                    folder={'Root'}
                    onClick={setShowContent}
                />
                {docsData.map((doc: BuilderDocType, index: number) => {
                    return <BuilderDocumentRow
                        FileName={doc.filename}
                        FileType={showContent}
                        Link={doc.href}
                        Timestamp={doc.timestamp}
                        SessionID={sessionInfo.sid}
                        setDeleteModal={(setDeleteModal)}
                        key={index}
                        Note={doc.note}
                    />
                })}
                {(!docsData || docsData.length === 0) &&
                    <tr><td colSpan={5}><Alert variant="primary">No documents to display.</Alert></td></tr>
                }
            </tbody>);
    }

    function buyerTableBody(): JSX.Element {
        if (buyerDocs.length > 0) {
            return <tbody>
                {buyerDocs.map((doc: any, index: number) => {
                    return <BuilderDocumentRow
                        FileName={doc.filename}
                        FileType={"Buyer"}
                        Link={doc.href}
                        Timestamp={doc.timestamp}
                        SessionID={sessionInfo.sid}
                        DocID={doc.docID}
                        MsgID={builderState.msgID}
                        setDeleteModal={(setDeleteModal)}
                        key={index}
                    />
                })}
            </tbody>
        }
        return <tbody>
                <tr><td style={{display: 'inline-table'}}>
                    <Alert style={{width: 'auto', position: 'absolute', left: '1%', right: '1%', marginTop: '1%'}}>
                        No documents to display. Click the upload button above to share documents with the builder.
                    </Alert>
                </td></tr>
        </tbody>
    }

    return <>
        <DeleteModal 
            show={deleteModal.show} 
            docname={deleteModal.dname} 
            isLoading={deleteLoading} 
            setDeleteModal={setDeleteModal} 
            handleDelete={handleDeleteBuyerDoc}
        />
        <UploadModal 
            showModal={showUploadModal} 
            handleBuyerDocUpload={handleBuyerDocUpload} 
            uploadDocLoading={uploadDocLoading} 
            file={uploadFile} 
            setFile={setUploadFile}
            setShowModal={setShowUploadModal}
            docUploadName={docToUpload.name}
            setDocToUpload={setDocToUpload}
        />
        <OverwriteModal 
            show={showOverwriteModal} 
            docname={docToUpload.name + '.' + docToUpload.ext} 
            isLoading={uploadDocLoading} 
            handleOverwrite={handleBuyerDocOverwrite} 
            handleCancel={handleCancelOverwriteModal}
        />
        <div>
            <BuilderInfo sessionInfo={sessionInfo} msgID={builderState.msgID}/>
        </div>
        <div style={{ height: '50%', overflow: "hidden", userSelect: 'none'}}>
            <div style={{height: '100%', marginBottom: '15px'}}>
            <Card className="card-list" style={{ height: '100%', width: '100%', position: 'relative' }}>
                <Card.Header>
                    <i style={{ marginLeft: "5px" }} className="fa-light fa-hard-drive" onClick={(e) => setShowContent('Root')} title="Go to root folder"></i>
                    <b style={{ marginLeft: "10px" }}>/ Builder Documents{showContent !== 'Root' ? ` / ${showContent}` : ''}</b>

                    <div className="card-tools">
                        <Button variant="primary" title="Refresh folder content" onClick={updateDocuments}><i className="fa-regular fa-rotate"></i></Button>
                    </div>
                </Card.Header>

                <Card.Body style={{overflow: 'auto'}}>
                    <Table hover>
                        {tableHeader('Seller')}
                        {sellerTableBody()}
                    </Table>
                </Card.Body>
            </Card>

            </div>
            
            {/* <div style={{height: '40%'}}>
                <Card className="card-list" style={{ height: '100%', width: '100%'}}>
                    <Card.Header>
                        <b>/ Share with Builder</b>
                        <div className="card-tools">
                            <Button variant="tool" title="Upload new document" onClick={(e) => {setShowUploadModal(true)}}><i className="fa-light fa-arrow-up-to-line"></i> Upload</Button>
                        </div>
                    </Card.Header>

                    <Card.Body style={{ overflow: 'auto' }}>
                        <Table hover>
                            {tableHeader('Buyer')}
                            {buyerTableBody()}
                        </Table>
                    </Card.Body>
                </Card>
            </div>  */}
        </div>
    </>
}